<template>  
    <div class="ml-2">
        <label class="text-xl ">Bill Summary</label>
    </div>
    <div class="formgrid grid">
        <div class="field col mx-2">
            <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 h-11rem">
                <div class="field  mt-2 ml-2 w-full">
                    <i class="pi pi-money-bill mr-1 font-medium" style="font-size: 1.5rem; color:#1d9de8"></i>  
                    <label v-if="billValueShow"  class="text-2xl font-medium ml-2"> {{formatCurrency(totalBillValue)}}</label> 
                    <i v-if="!billValueShow" class="pi pi-spin pi-spinner" style="font-size: 2rem; color:black;"></i> 
                    <div>
                        <label class="text-lg text-500">Total Bill Value</label>
                    </div>
                </div>  
                <div class="field mt-4 ml-2 w-full">
                    <div class="formgrid grid">
                        <div class="field col text-lg">
                            <label for="firstname2">Ex-GST:</label>
                            <div>
                                <label v-if="billValueShow" >{{formatCurrency(totalExGst)}}</label>
                                <i v-if="!billValueShow" class="pi pi-spin pi-spinner" style="font-size: 2rem; color:black;"></i> 
                            </div>
                        </div>
                        <div class="field col text-lg">
                            <label for="lastname2">GST:</label>
                            <div>
                                <label v-if="billValueShow" >{{formatCurrency(totalGst)}}</label>
                                <i v-if="!billValueShow" class="pi pi-spin pi-spinner" style="font-size: 2rem; color:black;"></i> 
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        </div>
        <div class="field col mx-2">
            <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 h-11rem">
                <div class="field  mt-2 ml-2 w-full">
                    <i class="pi pi-money-bill mr-1 font-medium" style="font-size: 1.5rem; color:#2eb318"></i>  
                    <label v-if="billValueShow" class="text-2xl font-medium ml-2"> {{formatCurrency(deptOrderValue)}}</label>
                    <i v-if="!billValueShow" class="pi pi-spin pi-spinner" style="font-size: 2rem; color:black;"></i>
                    <div>
                        <label class="text-lg text-500">Dept Order Value</label>
                    </div>
                </div>                   
            </div>
        </div>
        <div class="field col mx-2">
            <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 h-11rem"> 
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center ">
                        <div class="field  mt-2 ml-2 w-full">
                            <i class="pi pi-money-bill mr-1 font-medium" style="font-size: 1.5rem; color:#f21212"></i>  
                            <label v-if="billValueShow" class="text-2xl font-medium ml-2"> {{formatCurrency(pendingToBill)}}</label>
                            <i v-if="!billValueShow" class="pi pi-spin pi-spinner" style="font-size: 2rem; color:black;"></i>
                            <div>
                                <label class="text-lg text-500">Pending to Bill</label>
                            </div>
                        </div> 
                    </div>
                    <div class="flex align-items-center justify-content-center ">
                        <div class="field  mt-2 ml-2 w-full">
                            <i class="pi pi-percentage mr-1 font-medium" style="font-size: 1.5rem; color:#f2911a"></i>  
                            <label v-if="billValueShow" class="text-2xl font-medium ml-2"> {{formatNumber(pendingPercent)}}</label>
                            <i v-if="!billValueShow" class="pi pi-spin pi-spinner" style="font-size: 2rem; color:black;"></i>
                            <div>
                                <label class="text-lg text-500">Pending percent</label>
                            </div>
                        </div>
                    </div>
                </div>                  
            </div>
        </div>        
    </div>
            
</template>

<script>
import { deptOrderOnly } from '@/services/apiService';
export default {

    props:{
        bills:Array,

    },

    data(){
        return{
            totalBillValue:0,
            totalExGst:0,
            totalGst:0,
            deptOrderValue:0,
            pendingToBill:0,
            billValueShow:false,
            pendingPercent:0,
            tempOrders:[],
            deptOrders:[],
            deptOrderIds:[],
        }
    },

    mounted(){
        this.billSummary();
    },

    methods:{
        async billSummary(){  
            this.billValueShow = false;            
            this.totalBillValue = 0
            this.totalExGst = 0
            this.totalGst = 0
            this.deptOrderValue = 0

                await deptOrderOnly([]).then((res)=>{
                    this.deptOrders = res.data;
                }).catch((error)=>{
                    this.showErrorToast(error.response.data);                    
                });                
                    var tempOrders = [];
                    var counter = 0;
                    this.bills.forEach(e => {                    
                        counter++;
                        this.totalBillValue += e.grandTotal; 
                        this.totalExGst += e.exGstTotal;
                        this.totalGst += (e.cgst + e.sgst);
                        tempOrders.push(e.deptPoId);
                        if(counter==this.bills.length){
                            this.deptOrderIds = tempOrders.filter((value, index)=> tempOrders.indexOf(value)===index);
                            this.afterLoopCompletion();
                        }
                    });            
        },
        afterLoopCompletion(){
            this.deptOrders.forEach(e => {
                if(this.deptOrderIds.includes(e.id)){
                    this.deptOrderValue += e.value; 
                    this.getPending();
                }
            });
        },
        getPending(){
            this.pendingToBill = 0
            this.pendingPercent = 0;
            this.pendingToBill = this.deptOrderValue - this.totalBillValue;
            this.pendingPercent = 100 - ((this.totalBillValue / this.deptOrderValue) * 100);
            this.billValueShow = true;            
        },
        formatCurrency(value) {
                return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        formatNumber(value){
                return value.toLocaleString('en-IN', {maximumFractionDigits:2, minimumFractionDigits:2});
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 5000 });
        },

    }

}
</script>

<style>

</style>